<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="512"
        height="512"
        x="0"
        y="0"
        viewBox="0 0 24 24"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
        class="">
        <g>
            <path
                d="M8.685 18H3.5C1.21 18 0 16.79 0 14.5V9.312C0 4.597 3.823.343 8.348.022a9.026 9.026 0 0 1 7.007 2.615 9.041 9.041 0 0 1 2.622 7.036c-.318 4.514-4.574 8.326-9.292 8.326Zm.3-17c-.188 0-.377.007-.566.021C4.397 1.305 1 5.102 1 9.312V14.5c0 1.729.771 2.5 2.5 2.5h5.185c4.213 0 8.012-3.387 8.295-7.396a8.042 8.042 0 0 0-2.333-6.259A8.003 8.003 0 0 0 8.984 1Zm15.016 20.001v-4.726c0-2.698-1.424-5.354-3.717-6.93a.5.5 0 0 0-.566.824c2.025 1.393 3.283 3.731 3.283 6.105V21c0 1.652-1.087 1.999-2 1.999h-4.722c-2.374 0-4.714-1.258-6.107-3.283a.499.499 0 1 0-.824.566c1.578 2.293 4.233 3.717 6.932 3.717h4.722c1.851 0 3-1.149 3-2.999Z"
                fill="currentColor"
                opacity="1"
                data-original="currentColor"></path>
        </g>
    </svg>
</template>
